import type { GalleryPhoto, HeroSlide, NavLink, Prize, WheelReward } from "@/content/types";

/**
 * Every piece of editable copy/asset for the landing page lives here.
 * Changing a prize, a date or a link should never require touching JSX.
 */

export const site = {
  serverConnectUrl: "fivem://connect/play.offset.gg",
  /** What players type in the FiveM F8 console — shown as a copyable chip. */
  connectCommand: "connect play.offset.gg",
  discordUrl: "https://discord.gg/Sttftsg",
  rulesUrl: "https://docs.google.com/document/d/12eOl_vA7XgMA1M0s2saiMIjT_BGXSfK08Wd7Y4i4e40/edit?usp=sharing",
  copyrightHolder: "Nobel Actus Lda",
} as const;

/** In page order, so the scroll-spy highlight moves top to bottom. */
export const navLinks: readonly NavLink[] = [
  { name: "Comunidade", href: "#info", highlighted: false },
  { name: "Tickets PC", href: "#tickets", highlighted: false },
  { name: "Prémios", href: "#premios", highlighted: false },
  { name: "Galeria", href: "#galeria", highlighted: false },
  { name: "Regulamento", href: site.rulesUrl, highlighted: true, external: true },
];

export const heroSlides: readonly HeroSlide[] = [
  {
    id: "joga-e-ganha",
    title: "JOGA E GANHA",
    highlight: "PRÉMIOS!",
  },
];

export const community = {
  /** Formatted at render time with pt-PT separators. */
  memberCount: 60_000,
  headline: "Junta-te à nossa",
  headlineHighlight: "Comunidade!",
} as const;

export const giveaway = {
  /** Closing instant (Lisbon time) — drives both the countdown and the copy. */
  endsAt: "2026-10-15T23:59:59+01:00",
  endsAtLabel: "15 de outubro",
  specs: ["Ryzen 5 8400F", "32 RAM DDR5", "1TB SSD", "RTX 5060"],
} as const;

/** Auto-rotating showcase in the "Prémios roda da sorte" section. */
export const prizes: readonly Prize[] = [
  {
    id: "torero-xpr1",
    name: "Pegassi Torero XPR1",
    image: "images/prizes/gbtoreroxpr1.webp",
  },
];

export const wheelRewards: readonly WheelReward[] = [
  { id: "carro", label: "Carro Exclusivo", wide: true },
  { id: "tickets", label: "Tickets" },
  { id: "free-spins", label: "Free spins" },
  { id: "coins-vip", label: "Coins Vip" },
  { id: "dinheiro", label: "Dinheiro ingame" },
];

export const galleryPhotos: readonly GalleryPhoto[] = [
  { id: "wheel", image: "images/gallery/webp/wheel.webp", className: "order-1 col-span-2 row-span-2" },
  { id: "tuner", image: "images/gallery/webp/tuner_new.webp", className: "md:order-2" },
  { id: "sumol", image: "images/gallery/webp/sumol.webp", className: "md:order-3" },
  { id: "sa", image: "images/gallery/webp/sa.webp", className: "md:order-4" },
  { id: "car", image: "images/gallery/webp/car_new.webp", className: "order-2 md:order-5 col-span-2 row-span-2" },
  { id: "praia", image: "images/gallery/webp/praia.webp", className: "md:order-5" },
];

/** How long each prize stays on screen before the carousel advances. */
export const PRIZE_ROTATION_MS = 3000;
/** How long each hero slide stays on screen before the carousel advances. */
export const HERO_ROTATION_MS = 5000;
